import React from "react";
export function useObjectState(initialState) {
    const [state, setState] = React.useState(initialState);
    const set = React.useCallback((value) => {
        setState((currentState) => {
            return Object.assign(Object.assign({}, currentState), value);
        });
    }, [setState]);
    const reset = React.useCallback(() => {
        setState(initialState);
    }, [setState, initialState]);
    return React.useMemo(() => [state, set, reset], [state, set, reset]);
}
//# sourceMappingURL=useObjectState.js.map